import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface PageSectionProps {
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  as?: "section" | "div" | "article";
  fullWidth?: boolean;
  maxWidth?: "7xl" | "4xl";
}

const maxWidthClass = {
  "7xl": "max-w-7xl",
  "4xl": "max-w-4xl",
};

export function PageSection({
  children,
  className,
  innerClassName,
  as: Component = "section",
  fullWidth = false,
  maxWidth = "7xl",
}: PageSectionProps) {
  const innerClasses = cn(
    "mx-auto w-full px-6 md:px-12 lg:px-32 xl:px-44 2xl:px-56",
    maxWidthClass[maxWidth],
    innerClassName
  );

  if (fullWidth) {
    return (
      <Component className={className}>
        <div className={innerClasses}>{children}</div>
      </Component>
    );
  }

  return <Component className={cn(innerClasses, className)}>{children}</Component>;
}
